/**
 *
 * FreshPets Fonts
 *
 */

const fonts = {
    body: '"texta_regular", system-ui, sans-serif',
    heading: '"comfortaa_regular", system-ui, serif'
}

export default fonts